import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Lazy-load App only after DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  const container = document.getElementById("root");
  if (container) {
    const root = createRoot(container);

    root.render(<App />);
  }
});
